import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_ASSIGN_CONTAINER:
      return { ...action.assignContainer };
    default: return state;
  }
};
